import React from 'react';
import { unirLines } from '../data/mock';

export const Schedules = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative py-16 bg-gradient-to-r from-white to-amber-50 border-b-2 border-gray-200">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl font-bold mb-4 text-[#003d82]">Horários das Carreiras</h1>
            <p className="text-lg text-gray-600">
              Consulte os horários das linhas UNIR e CIM Cávado operadas pela Litoral Norte
            </p>
          </div>
        </div>
      </section>

      {/* UNIR Section */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-[#003d82] mb-3">Carreiras UNIR - Lote 3</h2>
              <p className="text-gray-600">
                Operamos 7 linhas da rede UNIR na região da Póvoa de Varzim e Vila do Conde
              </p>
            </div>
            
            <div className="grid md:grid-cols-2 gap-4 mb-8">
              {unirLines.map((line) => (
                <div key={line.number} className="bg-white border-2 border-gray-200 rounded-lg p-4 hover:border-[#f5a623] hover:shadow-md hover:bg-amber-50/30 transition-all">
                  <div className="flex items-center gap-3">
                    <div className="bg-[#003d82] text-white font-bold text-lg px-4 py-2 rounded-lg min-w-[60px] text-center flex items-center justify-center">
                      {line.number}
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">{line.name}</div>
                      {line.route && <div className="text-sm text-gray-600">{line.route}</div>}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-gradient-to-r from-blue-50 to-amber-50 border-l-4 border-[#003d82] rounded-lg p-6 text-center">
              <h3 className="text-lg font-semibold mb-2 text-[#003d82]">Consulte os Horários Oficiais</h3>
              <p className="mb-4 text-gray-700">
                Para horários detalhados e atualizados de todas as linhas
              </p>
              <a
                href="https://www.unirmobilidade.pt"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#003d82] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#002a5c] transition-all"
              >
                Aceder ao Site UNIR →
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CIM Cávado Section */}
      <section className="py-12 bg-amber-50/20">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-[#003d82] mb-3">Carreiras CIM Cávado</h2>
              <p className="text-gray-600">
                Linha Póvoa de Varzim - Barcelos da rede CIM Cávado
              </p>
            </div>
            
            <div className="bg-white border-2 border-gray-200 rounded-lg p-6 mb-8 hover:border-[#f5a623] hover:shadow-md hover:bg-amber-50/30 transition-all">
              <div className="flex items-center gap-3">
                <div className="bg-[#003d82] text-white font-bold text-lg px-4 py-2 rounded-lg flex items-center justify-center">
                  CIM Cávado
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Póvoa de Varzim - Barcelos</div>
                  <div className="text-sm text-gray-600">Ligação intermunicipal</div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-blue-50 to-amber-50 border-l-4 border-[#003d82] rounded-lg p-6 text-center">
              <h3 className="text-lg font-semibold mb-2 text-[#003d82]">Consulte os Horários Oficiais</h3>
              <p className="mb-4 text-gray-700">
                Para horários detalhados e atualizados
              </p>
              <a
                href="https://aitc.cimcavado.pt/horarios/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#003d82] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#002a5c] transition-all"
              >
                Aceder ao Site CIM Cávado →
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            {/* Operator Info */}
            <div className="bg-[#003d82] text-white p-6 rounded-lg mb-6">
              <h3 className="text-xl font-bold mb-3">Sobre os Serviços UNIR - Lote 3</h3>
              <p className="text-gray-200">
                Os serviços da rede UNIR do Lote 3 (Póvoa de Varzim e Vila do Conde) são explorados em consórcio pela 
                <strong> AVMinho</strong>, <strong>Transdev</strong> e <strong>Litoral Norte</strong>, garantindo 
                mobilidade de qualidade para a comunidade local.
              </p>
            </div>

            <div className="bg-[#f5a623]/10 border-l-4 border-[#f5a623] p-6 rounded-lg">
              <h3 className="text-xl font-bold text-[#003d82] mb-3">Informações Importantes</h3>
              <ul className="space-y-2 text-gray-700">
                <li>• Para horários atualizados e detalhados, consulte o <a href="https://www.unirmobilidade.pt" target="_blank" rel="noopener noreferrer" className="text-[#003d82] font-semibold hover:text-[#f5a623] underline">site oficial da UNIR</a></li>
                <li>• Em feriados e dias especiais, os horários podem sofrer alterações</li>
                <li>• Para informações sobre tarifas, consulte o site oficial da UNIR</li>
                <li>• Recomendamos que chegue à paragem com 5 minutos de antecedência</li>
                <li>• Para mais informações, contacte-nos através do telefone 252 692 266</li>
              </ul>
            </div>

            <div className="mt-8 text-center">
              <p className="text-gray-600 mb-4">
                Tem dúvidas sobre horários ou destinos?
              </p>
              <a
                href="tel:252692266"
                className="inline-flex items-center gap-2 bg-[#003d82] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#002a5c] transition-all"
              >
                Contacte-nos
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
